module.exports = __webpack_public_path__ + "static/media/cheese.a6238dea.svg";